import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RecordSgm } from '../data';
import { v4 as uuidv4 } from 'uuid';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SgmService } from '../../../../services/sgm/sgm.service';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';

type Row = {
  id: string;
  state: string;
  revision_number: string;
  revision_date: string | Date;
  concept: string;
  copy_control: boolean;
  copy_no_control: boolean;
  recipient: string;
}

const emptyForm: Row = {
  id: '',
  state: '',
  revision_number: '',
  revision_date: '',
  concept: '',
  copy_control: false,
  copy_no_control: false,
  recipient: ''
}

@Component({
  selector: 'ngx-sgm-anexo-cuatro',
  templateUrl: './anexo-cuatro.component.html',
})
export class AnexoCuatroComponent implements OnInit {
  @Input() stationId: string;
  @Input() record: RecordSgm;
  @Output() recordChange = new EventEmitter<Partial<RecordSgm & { row: any, event: string }> >();
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      state: {
        title: 'Estado',
        filter: true,
      },
      revision_number: {
        title: 'No. De Revisión',
        filter: true,
      },
      revision_date: {
        title: 'Fecha de Revisión',
        filter: true,
        valuePrepareFunction: (date) => moment(date).format('DD-MM-YYYY')
      },
      concept: {
        title: 'Concepto o parte del documento que ha sido modificado sobre la anterior revisión',
        filter: true,
      },
    },
    noDataMessage: 'Sin registros',
  };

  constructor(private sgmService: SgmService) {}

  ngOnInit() {
    this.loadData()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record.currentValue.rows) {
      this.source = new LocalDataSource(changes.record.currentValue.rows)
    }
  }

  async onCustom(event: { action: string; data: Row; }) {
    this.row = event.data;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');
    }
  }

  async remove () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: 'delete' })
    this.record.rows = this.record.rows.filter(row => row.id !== this.row.id)
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: this.row.id ? 'edit' : 'create' })
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  loadData () {
    this.row = { ...emptyForm };
    this.source = new LocalDataSource(this.record.rows)
  }

  async download () {
    await this.sgmService.downloadFormat({
      stationId: this.stationId,
      category: this.record.category,
      file: this.record.key,
      id_item: this.row.id
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
